import { useEffect, useState } from "react";
import { Form, InputGroup, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ConfirmDeactivateModal from "../ConfirmDeactivateModal";
import { adminOnlineStoreSectorToggleApi } from "../../../../admin/_actions";
import { globalAlert, globalLoader } from "../../../../actions/commonActions";
import { logOut } from "../../../../_shared/commonFunction";

const ZonesTable =({callBasicApi, history, zones}) =>{
    const { t } = useTranslation();
    const [zoneTab, setZoneTab] = useState('');
    const [sectorData, setSectorData] = useState([]);
    const [showToggleModal, setShowToggleModal] = useState(false);
    const [sectorCodes, setSectorCodes] = useState([]);
    const [flag, setFlag] = useState(false);
    const [suffixMsg, setSuffixMsg] = useState("Sector Code/s");

    const toggleSectorCodesApi = async (sectorCodes = [], flag = false) => {
      try {
          globalLoader(true);
          const res = await adminOnlineStoreSectorToggleApi({sectorCodes, flag});
          if (res?.data?.status === 200) {
              globalAlert("success", res?.data?.message);
              await callBasicApi();
          } else {
              globalAlert("error", res?.data?.message);
          }
          globalLoader(false);
      } catch (error) {
          globalAlert("error", error?.response?.data?.message);
          if (error?.response?.data?.status === 401) {
              logOut(history, "/admin/login");
          }
          globalLoader(false);
      }
    }

    useEffect(() => {
      if(!zoneTab) {
        setZoneTab(Object?.keys(zones)?.[0]);
      }
      setSectorData(zones?.[zoneTab]);
    }, [zoneTab]);

    const handleZoneTab = (zone) => {
        setZoneTab(zone);
    };

    const handleShowToggleModal = (sectorCodes = [], flag = false, suffixMsg = "Sector Code/s") => {
        setSectorCodes(sectorCodes);
        setFlag(flag);
        setSuffixMsg(suffixMsg);
        setShowToggleModal(true);
    };

    const handleToggleConfirm = async () => {
        await toggleSectorCodesApi(sectorCodes, !flag);
        setShowToggleModal(false);
        setSectorCodes([]);
        setFlag(false);
        // Force a re-render by updating zoneTab
        setZoneTab(prev => prev === zoneTab ? '' : zoneTab);
      };

    const handleEnableAll = () => {
        const allSectorCodes = sectorData.map(row => row.areaCode);
        handleShowToggleModal(allSectorCodes, false, "all sector codes");
    };

    const handleDisableAll = () => {
        const allSectorCodes = sectorData.map(row => row.areaCode);
        handleShowToggleModal(allSectorCodes, true, "all sector codes");
    };
    return (
        <>
          {showToggleModal && <ConfirmDeactivateModal
              show={showToggleModal}
              onClose={() => setShowToggleModal(false)}
              onConfirm={handleToggleConfirm}
              isActive={flag} 
              suffixMsg={suffixMsg}
          />}
          {/* <InputGroup className="mb-3">
            <Form.Control placeholder="Search" className="search-input" />
          </InputGroup> */}

          <div className="zone-tabs mb-3">
            {Object?.keys(zones)?.map((zone) => (
              <div
                key={zone}
                className={`zone-tab ${zoneTab === zone ? "active" : ""}`}
                onClick={() => handleZoneTab(zone)}
              >
                {zone}
              </div>
            ))}
          </div>

          <div className="mb-3 d-flex gap-3">
            <button className="btn btn-enable mr-4" onClick={handleEnableAll}>{t("admin.zones.enableAllSectorCode")}</button>
            <button className="btn btn-disable" onClick={handleDisableAll}>{t("admin.zones.disableAllSectorCode")}</button>
          </div>

          <Table bordered hover className="table-orders">
            <thead>
              <tr>
                <th width="10%">{t("common.serialNo")}</th>
                <th width="40%">{t("admin.zones.sectorCode")}</th>
                <th width="25%">{t("common.status")}</th>
                <th width="25%">{t("common.action")}</th>
              </tr>
            </thead>
            <tbody>
              {sectorData?.map((row, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{row?.areaCode}</td>
                  <td>{row?.isOnlineStoreEnabled ? t("common.enabled") : t("common.disabled")}</td>
                  <td>
                    <button
                      className={`btn btn-${row?.isOnlineStoreEnabled ? "disable" : "enable"}`}
                      onClick={() => handleShowToggleModal([row?.areaCode], row?.isOnlineStoreEnabled, `this sector code: ${row?.areaCode}`)}
                    >
                      {row?.isOnlineStoreEnabled ? t("common.disable") : t("common.enable")}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
    )
}

export default ZonesTable;